var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSportsNutrition = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Fitness-Shaker--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Fitness Shaker Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15 2h-1.25a0.5 0.5 0 0 1 -0.5 -0.5v-0.25a1.25 1.25 0 0 0 -2.5 0v0.25a0.5 0.5 0 0 1 -0.5 0.5H9a2.5 2.5 0 0 0 -2.5 2.5v1A0.5 0.5 0 0 0 7 6h10a0.5 0.5 0 0 0 0.5 -0.5v-1A2.5 2.5 0 0 0 15 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7.5H7a0.5 0.5 0 0 0 -0.5 0.5v1.1a1.49 1.49 0 0 0 0.42 1l1.48 1.58a0.49 0.49 0 0 1 0 0.69l-1.47 1.49a1.47 1.47 0 0 0 -0.43 1.05v6.59A2.5 2.5 0 0 0 9 24h6a2.5 2.5 0 0 0 2.5 -2.5v-6.58a1.53 1.53 0 0 0 -0.45 -1.07l-1.48 -1.45a0.52 0.52 0 0 1 -0.16 -0.35 0.47 0.47 0 0 1 0.15 -0.35l1.51 -1.56a1.47 1.47 0 0 0 0.43 -1.05V8a0.5 0.5 0 0 0 -0.5 -0.5ZM14.39 17l-2.78 3.24a0.25 0.25 0 0 1 -0.44 -0.16v-2.16a0.5 0.5 0 0 0 -0.5 -0.5H9.8a0.25 0.25 0 0 1 -0.23 -0.15 0.27 0.27 0 0 1 0 -0.27l2.78 -3.24a0.25 0.25 0 0 1 0.44 0.16v2.16a0.5 0.5 0 0 0 0.5 0.5h0.87a0.25 0.25 0 0 1 0.23 0.15 0.27 0.27 0 0 1 0 0.27Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSportsNutrition);
export default ForwardRef;